﻿import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "angular-2-local-storage";

// Import Enum
import { SortType } from "../../../enum/jubili/company-manage/sort-type";
// Import Model
import { GetUserModel, UserListIndexModel, UserlistModel } from "../../../model/jubili/user-manage/get-users";
import { SortCompanyModel } from "../../../model/jubili/company-manage/company-sort";
import { UserManageService } from "../../../service/api/jubili/user-manage.service";
import { AuthenticationService } from "../../../service/api/auth/auth.service";
import { ResetPasswordModalComponent } from "./reset-password-modal/reset-password-modal.component";
import { element } from "@angular/core/src/render3";

@Component({
    selector: "bo-jub-user-manage",
    templateUrl: "./user-manage.component.html",
    styleUrls: ["./user-manage.component.scss"]
})

export class UserManageComponent implements OnInit {

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService,
        private userManageService: UserManageService,
        private AuthService: AuthenticationService
    ) { }
    @ViewChild("resetPasswordModal") resetPasswordModal: ResetPasswordModalComponent;

    userList: Array<UserlistModel> = new Array<UserlistModel>();
    userIndex: UserListIndexModel = new UserListIndexModel();
    getUser: GetUserModel = new GetUserModel();

    countAllEmp: number = 0;
    countActiveEmp: number = 0;
    countInActiveEmp: number = 0;

    // using for page list (default)
    page: number = 1;
    lastPage: number = 1;
    limit: number = 50;
    countall: number = 0;
    status: string = "";
    // using for search
    searchusername: string = "";
    searchcompanyname: string = "";
    // using for sort (default)
    sortCol: string = "createdate";
    sortType: number = SortType.DESC;

    ngOnInit(): void {
        this.setDataUserlist();
        this.getCountUserStatus();
    }
    setDataUserlist(): void {
        this.getUser.page = ((this.page - 1) * 50) + 1;
        this.getUser.limit = this.limit * this.page;
        this.getUser.sortcol = this.sortCol;
        this.getUser.sorttype = this.sortType;
        this.getUser.status = this.status;

        this.userManageService.getAllUserBackOffice(this.getUser)
        .subscribe(
            Response => {
                this.userIndex = Response;
                this.userList = this.userIndex.data; // set data to show list
                this.countall = this.userIndex.count;
                this.lastPage = Math.ceil((this.userIndex.count) / (this.limit));

                this.userList.forEach(element => {
                  this.AuthService.checkRegister(element.userEmail)
                    .subscribe(
                        Result => {
                          element.isRegister = Result !== 1 ? true : false;
                        }
                      );
                });
            },
            err => {
                // unauthorized refresh token
                console.log("unauth");
                if (err.status === 401) {
                    this.AuthService.refreshSessionToken()
                    .subscribe(
                        Response => {
                            // Update session
                            this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);

                            this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);
                            this.setDataUserlist();
                        }
                    );
                } else {
                    this.router.navigate(["/home"]);
                }
            }
        );
    }

    getCountUserStatus(){
      this.userManageService.getCountUserStatusBackOffice(this.searchcompanyname, this.searchusername, this.status).subscribe(res => {
        res.forEach(item => {
          if(item.status == true){
            this.countActiveEmp = item.countUser;
          }
          else{
            this.countInActiveEmp = item.countUser;
          }
        })
        this.countAllEmp = this.countActiveEmp + this.countInActiveEmp;
      })
    }

    openResetPassword(user: UserlistModel): void {
        this.resetPasswordModal.openConfirm(user);
    }

    confirmResetPassword(targetEmail: string): void {
        // actor ต้องมาจาก session ของ CS ที่ login อยู่จริงเท่านั้น ห้าม hardcode
        // เพราะ audit log ฝั่ง JUBILI บันทึกตามค่าที่ส่งไป
        const actorEmail = this.localStorageService.get<string>("userEmail");
        // userSurrKey ถูกเซ็ตตอนเข้า Jubili จากหน้า home (home.component.ts)
        // AuthGuardJubili เช็ค !== undefined แต่ library คืน null เมื่อไม่มีค่า จึงกันเคสนี้ไม่ได้
        // ต้องเช็คเองก่อนยิง ไม่งั้นจะส่ง actorUserSurrKey = 0 ไปลง audit log
        const actorUserSurrKey = Number(this.localStorageService.get<any>("userSurrKey"));

        if (!actorUserSurrKey || !actorEmail) {
            this.resetPasswordModal.showError(
                "ไม่พบข้อมูลผู้ใช้งานใน session กรุณา login ใหม่แล้วลองอีกครั้ง");

            return;
        }

        this.userManageService.autoResetPassword(actorUserSurrKey, actorEmail, targetEmail)
            .subscribe(
                Response => {
                    // BE ใช้ excludeNulls - key newPassword อาจหายไปทั้งตัว จึงเช็คแบบ falsy
                    if (!Response || !Response.newPassword) {
                        this.resetPasswordModal.showError(
                            (Response && Response.message) || "ไม่ได้รับรหัสผ่านใหม่จากระบบ กรุณาลองใหม่อีกครั้ง");

                        return;
                    }

                    // ห้าม log รหัสลง console / analytics
                    this.resetPasswordModal.showResult(Response.newPassword);
                },
                err => {
                    // 401 ไม่ต้อง handle ที่นี่ - InterceptorService จัดการ refresh token / เด้ง login ให้แล้ว
                    // error shape มาจากภายนอก การันตีเป็น string ไม่ได้ จึง cast ก่อนใช้ indexOf
                    let message = (err && err.error && typeof err.error.message === "string")
                        ? err.error.message
                        : "reset password ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";

                    // ข้อความ actor ไม่ match เป็นภาษาอังกฤษเชิงเทคนิค CS อ่านแล้วไม่รู้ต้องทำอะไรต่อ
                    // เคสนี้เกิดจาก session ค้าง/ไม่ sync ทางแก้คือ login ใหม่
                    if (message.indexOf("actorUserSurrKey") !== -1 || message.indexOf("actorEmail") !== -1) {
                        message = message + " — ข้อมูล session ไม่ตรงกัน กรุณา login ใหม่แล้วลองอีกครั้ง";
                    }

                    this.resetPasswordModal.showError(message);
                }
            );
    }

    changeStatus(status: string){
      this.status = status;
      this.setDataUserlist();
    }

    searchUser(): void {
        this.getUser.usernamesearch = this.searchusername;
        this.getUser.companynamesearch = this.searchcompanyname;
        this.page = 1;
        this.setDataUserlist();
        this.getCountUserStatus();
    }
    searchCompanyname(): void {
        this.getUser.companynamesearch = this.searchcompanyname;
        this.setDataUserlist();
        this.getCountUserStatus();
    }
    // sort user list
    sortList(event: SortCompanyModel): void {
        this.sortCol = event.sortCol;
        this.sortType = event.sortType;
        this.setDataUserlist();
    }
    backPage(): void {
        if (this.page > 1) {
            this.page--;
            this.setDataUserlist();
        }
    }

    nextPage(): void {
        if (this.page < this.lastPage) {
            this.page++;
            this.setDataUserlist();
        }
    }

    goTofirstPage(): void {
        if (this.page > 1) {
            this.page = 1;
            this.setDataUserlist();
        }
    }

    goTolastPage(): void {
        if (this.page < this.lastPage) {
            this.page = this.lastPage;
            this.setDataUserlist();
        }
    }
}
